module.exports = __webpack_public_path__ + "img/public/siteImages/showAllCars.svg?9f623247";